// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"db6ceb5d","238":"26dfd9c6","488":"c99e88db","885":"622cc0fa"}[chunkId] + ".chunk.js";
};